import React, { useContext } from "react";
import { UserContext } from "../providers/UserProvider";
import { Router, Link } from "@reach/router";
import AddTutorialAnonymous from "./AddTutorialAnonymous";
import { auth } from "../firebase";
import logo from '../static/logo.png';

function Navigation() {

  const user = useContext(UserContext);

  // if (user) {
  // const {photoURL, displayName, email} = user;
  // }

  return (
    <div className="mb-2">
      <nav className="navbar navbar-expand navbar-dark bg-banner">
        <div className="container">
        <img className="thumbnail" src={logo} alt="Logo" />;
        <Link className="nav-link" to="/">
          <div className="navbar-brand">
            APPaderno
            <small>La rete del commercio e dei<br/>servizi VICINO a te</small>
          </div>
        </Link>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        {user ? (
          <div className="collapse navbar-collapse" id="navbar">
            <ul className="navbar-nav mr-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">Lista esercizi</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="addtutorial">Aggiungi Esercizio</Link>
              </li>
            </ul>
          <div className="navbar-nav ml-auto">
            <button className="btn btn-primary mr-2" onClick = {() => {auth.signOut()}}>Sign out</button>
            <li className="nav-item">
              <span className="mr-2 text-white">{user.displayName}</span>
              <img className="img-profile rounded-circle" src={user.photoURL} />
            </li>
          </div>
          </div>
        )
        : (
          <div className="collapse navbar-collapse" id="navbar">
            <ul className="navbar-nav mr-auto">
              <li className="nav-item">
                <Link className="nav-link" to="nuovo_esercizio">Inserisci il tuo esercizio</Link>
              </li>
            </ul>
          </div>
        )}
        </div>
      </nav>
      <Router>
        <AddTutorialAnonymous path="nuovo_esercizio" />
      </Router>
    </div>
  );
}

export default Navigation;
